import { Fragment } from "react";

const WHO = { richiedente: "Richiedente", coobbligato: "Coobbligato" };

export const ConsentPicker = ({ consents, value, onChange, testid = "consents" }) => {
  if (!consents?.length) return null;
  const set = (k, v) => onChange({ ...value, [k]: value[k] === v ? undefined : v });
  const groups = ["richiedente", "coobbligato"].filter((w) => consents.some((c) => c.who === w));
  return (
    <div className="grid grid-cols-[auto_1fr] items-center gap-x-3 gap-y-1.5 rounded-md border border-border p-3 text-sm" data-testid={testid}>
      {groups.map((w) => (
        <Fragment key={w}>
          <p className="col-span-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground pt-1">{WHO[w]}</p>
          {consents.filter((c) => c.who === w).map((c) => (
            <Fragment key={c.key}>
              <span>Consenso {c.num}</span>
              <div className="flex gap-1.5">
                {[["ok", "Do"], ["ko", "Nego"]].map(([v, l]) => (
                  <button key={v} type="button" onClick={() => set(c.key, v)} data-testid={`${testid}-${c.key}-${v}`}
                    className={`rounded-md border px-3 py-1 text-xs font-medium transition-colors ${value[c.key] === v ? (v === "ok" ? "border-emerald-600 bg-emerald-600 text-white" : "border-rose-600 bg-rose-600 text-white") : "border-border hover:bg-muted"}`}>{l}</button>
                ))}
              </div>
            </Fragment>
          ))}
        </Fragment>
      ))}
      <p className="col-span-2 text-xs text-muted-foreground pt-1">Lascia vuoto ciò che non vuoi indicare: la casella resta bianca.</p>
    </div>
  );
};
